import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { BlogDetailComponent } from '../../blogger/blog-detail/blog-detail.component';
@Component({
    selector: 'app-read-blog',
    templateUrl: './read-blog.component.html',
    styleUrls: ['./read-blog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, BlogDetailComponent],
    standalone: true,
})
export default class ReadBlogComponent {
    content = input.required();
}
